import React from 'react';
import TabelaCrud from '../components/TabelaCrud';
import { getCurrentTenantId } from '../services/api';
import { useCreches } from '../hooks/useCreches';

interface ControleAcesso { id: number; creche_id: number; usuario_id: number; perfil: string; biometria_habilitada: boolean; reconhecimento_facial: boolean; }
interface Monitoramento { id: number; creche_id: number; camera_nome: string; local: string; status: string; integracao: string; }
interface ProtocoloEmergencia { id: number; creche_id: number; tipo: string; procedimento: string; contato_principal: string; }
interface ContatoEmergenciaPrioritario { id: number; creche_id: number; aluno_id: number; nome: string; telefone: string; prioridade: number; relacao: string; }

export default function SegurancaPage() {
  const { options } = useCreches();
  const tenantScoped = Boolean(getCurrentTenantId());

  return (
    <div className="stack-cadastros">
      <TabelaCrud<ControleAcesso>
        titulo="Segurança — Controle de Acesso"
        endpoint="/seguranca/acesso"
        colunas={[{ chave: 'id', label: 'ID' }, { chave: 'usuario_id', label: 'Usuário' }, { chave: 'perfil', label: 'Perfil' }]}
        itemVazio={{ creche_id: 0, usuario_id: 0, perfil: 'educador', biometria_habilitada: false, reconhecimento_facial: false }}
        validateItem={(i) => ((!tenantScoped && !i.creche_id) || !i.usuario_id || !i.perfil ? 'Preencha usuário e perfil.' : null)}
        renderFormulario={(i, onChange) => (
          <>
            <div className="linha-campos linha-3">
              <label className={tenantScoped ? 'campo-tenant-oculto' : undefined}>Creche<select value={i.creche_id ?? 0} onChange={(e) => onChange('creche_id', Number(e.target.value))}><option value={0}>Selecione...</option>{options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</select></label>
              <label>Usuário ID<input type="number" value={i.usuario_id ?? 0} onChange={(e) => onChange('usuario_id', Number(e.target.value))} /></label>
              <label>Perfil<select value={i.perfil ?? 'educador'} onChange={(e) => onChange('perfil', e.target.value)}><option value="admin">Admin</option><option value="educador">Educador</option><option value="familia">Família</option></select></label>
            </div>
            <label><input type="checkbox" checked={i.biometria_habilitada ?? false} onChange={(e) => onChange('biometria_habilitada', e.target.checked)} /> Biometria habilitada</label>
            <label><input type="checkbox" checked={i.reconhecimento_facial ?? false} onChange={(e) => onChange('reconhecimento_facial', e.target.checked)} /> Reconhecimento facial habilitado</label>
          </>
        )}
      />

      <TabelaCrud<Monitoramento>
        titulo="Segurança — Câmeras e Monitoramento"
        endpoint="/seguranca/monitoramento"
        colunas={[{ chave: 'id', label: 'ID' }, { chave: 'camera_nome', label: 'Câmera' }, { chave: 'local', label: 'Local' }, { chave: 'status', label: 'Status' }]}
        itemVazio={{ creche_id: 0, camera_nome: '', local: '', status: 'ativo', integracao: '' }}
        validateItem={(i) => ((!tenantScoped && !i.creche_id) || !i.camera_nome || !i.local ? 'Preencha os campos obrigatórios da câmera.' : null)}
        renderFormulario={(i, onChange) => (
          <>
            <div className="linha-campos linha-2">
              <label className={tenantScoped ? 'campo-tenant-oculto' : undefined}>Creche<select value={i.creche_id ?? 0} onChange={(e) => onChange('creche_id', Number(e.target.value))}><option value={0}>Selecione...</option>{options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</select></label>
              <label>Câmera<input value={i.camera_nome ?? ''} onChange={(e) => onChange('camera_nome', e.target.value)} /></label>
            </div>
            <div className="linha-campos linha-3">
              <label>Local<input value={i.local ?? ''} onChange={(e) => onChange('local', e.target.value)} /></label>
              <label>Status<select value={i.status ?? 'ativo'} onChange={(e) => onChange('status', e.target.value)}><option value="ativo">Ativo</option><option value="inativo">Inativo</option></select></label>
              <label>Integração<input value={i.integracao ?? ''} onChange={(e) => onChange('integracao', e.target.value)} /></label>
            </div>
          </>
        )}
      />

      <TabelaCrud<ProtocoloEmergencia>
        titulo="Segurança — Protocolos de Emergência"
        endpoint="/seguranca/protocolos"
        colunas={[{ chave: 'id', label: 'ID' }, { chave: 'tipo', label: 'Tipo' }, { chave: 'contato_principal', label: 'Contato' }]}
        itemVazio={{ creche_id: 0, tipo: 'incendio', procedimento: '', contato_principal: '' }}
        validateItem={(i) => ((!tenantScoped && !i.creche_id) || !i.tipo || !i.procedimento || !i.contato_principal ? 'Preencha os campos obrigatórios do protocolo.' : null)}
        renderFormulario={(i, onChange) => (
          <>
            <div className="linha-campos linha-2">
              <label className={tenantScoped ? 'campo-tenant-oculto' : undefined}>Creche<select value={i.creche_id ?? 0} onChange={(e) => onChange('creche_id', Number(e.target.value))}><option value={0}>Selecione...</option>{options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</select></label>
              <label>Tipo<select value={i.tipo ?? 'incendio'} onChange={(e) => onChange('tipo', e.target.value)}><option value="incendio">Incêndio</option><option value="invasao">Invasão</option><option value="emergencia_medica">Emergência médica</option></select></label>
            </div>
            <label>Procedimento<textarea rows={3} value={i.procedimento ?? ''} onChange={(e) => onChange('procedimento', e.target.value)} /></label>
            <label>Contato principal<input value={i.contato_principal ?? ''} onChange={(e) => onChange('contato_principal', e.target.value)} /></label>
          </>
        )}
      />

      <TabelaCrud<ContatoEmergenciaPrioritario>
        titulo="Segurança — Contatos de Emergência por Criança"
        endpoint="/seguranca/contatos-emergencia"
        colunas={[{ chave: 'id', label: 'ID' }, { chave: 'aluno_id', label: 'Criança ID' }, { chave: 'nome', label: 'Nome' }, { chave: 'prioridade', label: 'Prioridade' }]}
        itemVazio={{ creche_id: 0, aluno_id: 0, nome: '', telefone: '', prioridade: 1, relacao: '' }}
        validateItem={(i) => ((!tenantScoped && !i.creche_id) || !i.aluno_id || !i.nome || !i.telefone ? 'Preencha os campos obrigatórios de contato de emergência.' : null)}
        renderFormulario={(i, onChange) => (
          <>
            <div className="linha-campos linha-2">
              <label className={tenantScoped ? 'campo-tenant-oculto' : undefined}>Creche<select value={i.creche_id ?? 0} onChange={(e) => onChange('creche_id', Number(e.target.value))}><option value={0}>Selecione...</option>{options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</select></label>
              <label>Criança ID<input type="number" value={i.aluno_id ?? 0} onChange={(e) => onChange('aluno_id', Number(e.target.value))} /></label>
            </div>
            <div className="linha-campos linha-3">
              <label>Nome<input value={i.nome ?? ''} onChange={(e) => onChange('nome', e.target.value)} /></label>
              <label>Telefone<input value={i.telefone ?? ''} onChange={(e) => onChange('telefone', e.target.value)} /></label>
              <label>Prioridade<input type="number" value={i.prioridade ?? 1} onChange={(e) => onChange('prioridade', Number(e.target.value))} /></label>
            </div>
            <label>Relação<input value={i.relacao ?? ''} onChange={(e) => onChange('relacao', e.target.value)} /></label>
          </>
        )}
      />
    </div>
  );
}

